import { Box, Typography } from "@mui/material"
import tractor from './images/IMG_2644.jpg'
import pond from './images/IMG_2617.jpg'
const Mast: React.FC = () => {
    return (
        <Box
        sx={{
                marginTop: "128px",
                display: "flex",
                justifyContent: "center",
                marginBottom: "64px"
              }}
      >
        <img src={tractor} alt="profile" style={{
          maxHeight: "256px",
          borderRadius: "400px",
        }}/>
        <Typography variant="h1" color="primary" sx={{padding:'60px'}}>Farm Life</Typography>
        <img src={pond} alt="profile" style={{
          maxHeight: "256px",
          borderRadius: "400px",
        }}/>
      </Box>
    )
}
export default Mast;